export const MISSING_TRANSLATION = "missingTranslation";
export const MESSAGE = "message";
export const TRANSLATIONS = "translations";
export const DATA = "data";
export const CODE = "code";
export const LANGUAGE = "language";
export const ORDER = "order";
export const STOPS = "stops";
export const SLICES = "slices";
export const CART_ITEMS = "cart_items";
export const OFFER = "offer";
export const ID = "id";
export const NAME = "name";
export const DEPARTURE_STOP = "departureStop";
export const REFRESH_OFFERS = "refreshOffers";
export const RULE = "rule";
export const SLUG = "slug";
export const SEAT = "seat";
export const CREATED_AT = "createdAt";
export const ROUTE_NAME = "routeName";
export const EXTERNAL_ROUTE_NAME = "externalRouteName";
export const EXTERNAL_CARRIER_NAME = "externalCarrierName";
export const CARRIER_NAME = "carrierName";
export const DEPARTURE_CITY = "departureCity";
export const DEPARTURE_CITY_SLUG = "departureCitySlug";
export const DEPARTURE_TIME = "departureTime";
export const ARRIVAL_TIME = "arrivalTime";
export const ACCESSES = "accesses";
export const ARRIVAL_PLACE = "arrivalPlace";
export const ARRIVAL_PLATFORM = "arrivalPlatform";
export const ARRIVAL_CITY_ID = "arrivalCityId";
export const DEPARTURE_PLACE = "departurePlace";
export const DEPARTURE_CITY_ID = "departureCityId";
export const DEPARTURE_PLATFORM = "departurePlatform";
export const ARRIVAL_CITY = "arrivalCity";
export const ARRIVAL_CITY_SLUG = "arrivalCitySlug";
export const ARRIVAL_STATION = "arrivalStation";
export const DEPARTURE_STATION = "departureStation";
export const ARRIVAL_DATE = "arrivalDate";
export const DEPARTURE_DATE = "departureDate";
export const RETURN_ROUTE_ID = "returnRouteId";
export const QTY = "qty";
export const PAID = "paid";
export const BOOKED = "booked";
export const PLACE = "place";
export const PLATFORM = "platform";
export const ALL_CITIES = "allCities";
export const RECENT_CITIES = "recentCities";
export const COUNTRIES = "countries";
export const LABEL = "label";
export const BUSES = "buses";
export const ROUTES = "routes";
export const REVIEWS = "reviews";
export const GENERAL_INFO = "generalInfo";
export const TOCOBUS_OFFERS = "tocobusOffers";
export const KLR_OFFERS = "klrOffers";
export const CONTRABUS_OFFERS = "contrabusOffers";
export const OCTOBUS_OFFERS = "octobusOffers";
export const BLA_BLA_CAR_OFFERS = "blaBlaCarOffers";
export const RESULTS = "results";
export const ROUTE = "route";
export const BUS = "bus";
export const SOURCE = "source";
export const COMPANY = "company";
export const LOGO_URL = "logoUrl";
export const ROUTE_ID = "routeId";
export const CARRIAGE = "carriage";
export const CARRIAGES = "carriages";
export const CARRIAGE_ID = "carriageId";
export const IS_GEOLOCATION = "isGeolocation";
export const COORDS_UPDATED_AT = "coordsUpdatedAt";
export const WEBSITE_ORDERS = "websiteOrders";
export const PAYMENT_STATUS = "paymentStatus";
export const SEGMENT_ID = "segmentId";
export const SLICE_ID = "sliceId";
export const IS_INVOICE_CHECKED = "isInvoiceChecked";
export const REGULATION_AGREEMENT = "regulationsAgreement";
export const MARKETING_AGREEMENT = "marketingAgreement";
export const INITIAL_WAY_PASSENGERS = "initialPassengers";
export const PASSENGERS = "passengers";
export const FIRST_NAME = "firstName";
export const LAST_NAME = "lastName";
export const EMAIL = "email";
export const PHONE = "phone";
export const PHONES = "phones";
export const NOTE = "note";
export const TYPE = "type";
export const PAYMENT_METHOD = "paymentMethod";
export const CARD = "card";
export const DRIVER = "driver";
export const CASH = "cash";
export const DESCRIPTION = "description";
export const SERVICES = "services";
export const RULES = "rules";
export const SEATS = "seats";
export const BUS_SEAT_ID = "busSeatId";
export const BUS_SEAT_LABEL = "busSeatLabel";
export const OCTOBUS_RACE_ID = "octobusRaceId";
export const BLA_BLA_CAR_RACE_ID = "blaBlaCarRaceId";
export const REFUND_RULES = "refundRules";
export const OFFER_ID = "offerId";

export const TAX_ID = "taxId";
export const COMPANY_NAME = "companyName";
export const COMPANY_ADDRESS = "companyAddress";
export const ZIP_CODE = "zipCode";
export const CITY = "city";
export const COUNTRY = "country";

export const ADULT = "adult";
export const CHILD = "child";

export const DISCOUNT = "discount";

export const VK = "vk";
export const FACEBOOK = "facebook";
export const INSTAGRAM = "instagram";
export const PINTEREST = "pinterest";
export const YOUTUBE = "youtube";

export const PRICE = "price";
export const INITIAL_PRICE = "initialPrice";
export const AMOUNT = "amount";
export const PRICES = "prices";
export const CURRENCY = "currency";
export const IS_INITIAL = "isInitial";

export const PASSENGER = "passenger";
export const PASSENGER_ORDERS = "passengerOrders";
export const TOKEN = "token";

export const PHONE_OR_EMAIL = "phoneOrEmail";
export const PASSWORD = "password";
export const REPEAT_PASSWORD = "repeatPassword";
export const PASSENGER_LOGIN = "passengerLogin";
export const REGISTER_PASSENGER = "registerPassenger";

export const NOT_AUTHENTICATED = "You need to be authenticated";
export const JWT_EXPIRED = "jwt expired";
export const PASSENGER_NOT_EXISTS = "Passenger doesn't exists";

export const NETWORK_ONLY = "network-only";

export const PASSENGER_ORDER = "passengerOrder";
export const PASSENGER_OFFER = "passengerOffer";
export const UNPAID_ORDERS_IDS = "unpaidOrdersIds";

export const PATH = "path";

export const PROMOCODE = "promocode";
export const INVALID_PROMOCODE = "Invalid promocode";

export const CHECK_CONTRABUS_BOOKING = "checkContrabusBooking";
export const IS_VALID = "isValid";
export const MESSAGE_HTML = "messageHtml";

export const ORDER_LOCAL_STORAGE_KEY = "__order__";

export const CACHE_CONTROL = "Cache-Control";

export const SUPPORT = "support";
export const DRIVERS = "drivers";
export const PRICE_QUALITY = "priceQuality";
export const COMFORT = "comfort";
